function isVariantLabels(value) {
  return typeof value === "string" || value === false || Array.isArray(value);
}
export {
  isVariantLabels
};
